module.exports = __webpack_public_path__ + "static/media/chess_game.924128e7.png";